import { createBwTheme } from "@bw/material";

/** Staff apps use Hanken Grotesk (loaded in index.html); the player app keeps Inter. */
const STAFF_FONT_FAMILY = '"Hanken Grotesk", system-ui, sans-serif';

export function createBusinessTheme() {
  return createBwTheme({
    bw: {
      audience: "business",
      density: "compact",
      minimumTouchTarget: 44,
    },
    colorSchemes: {
      light: {
        palette: {
          secondary: { main: "#755b16" },
          background: { default: "#f5f7f5" },
          semantic: {
            primary: "#0d6755",
            surface: "#ffffff",
            selected: "#d5efe8",
            onSelected: "#064c3e",
            pending: "#8a5700",
          },
        },
      },
      dark: {
        palette: {
          secondary: { main: "#e4c46d" },
          background: { default: "#0e1211" },
          semantic: {
            surface: "#171c1a",
            primary: "#83d9c3",
            onPrimary: "#00382d",
            selected: "#174c40",
            onSelected: "#b8f1e1",
            pending: "#e9bd64",
          },
        },
      },
    },
    typography: { fontFamily: STAFF_FONT_FAMILY },
    shape: { borderRadius: 8 },
  });
}
